<template>
  <div class="alert">
    <!-- 韓国ホテルご予約に関するご案内 -->
    <div
      v-if="targetCountry === '19'"
      class="alert alert-danger bar_title"
      role="alert"
    >
      <div class="Bg_f7f5f0">
        <button
          type="button"
          class="alert-guidance-btn reservation"
          @click="showKoreaGuidanceModal = true"
        >
          <p class="mgr10 fs18"><i class="fa fa-exclamation-triangle"></i></p>
          <h5 class="mgr40 fs14">韓国ホテルご予約のお客様</h5>
          <p class="alert-guidance-details fwB">
            <i class="fa fa-chevron-circle-right fs16"></i>&nbsp;詳細はこちら
          </p>
        </button>
      </div>
    </div>

    <tk-modal
      v-if="showKoreaGuidanceModal"
      modal-size="lg"
      no-show-header
      :no-sp-fullscreen="true"
      style="padding-right: 0px;"
    >
      <h3 class="text-center pdt30">
        <strong>韓国ホテルご予約のお客様</strong>
      </h3>
      <br />
      <br />
      <div class="row pdl40 pdr40 pdb30">
        <span style="font-size: 14px;">
          <strong>
            韓国の法律により、未成年の単独宿泊、未成年者同士の宿泊は不可です。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>
            また異性同士の宿泊は複数名のうち1名でも未成年者にあたる場合、宿泊は禁止されています。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>ご予約が確定できませんのでご了承ください。</strong>
        </span>
      </div>
      <div class="Price_back2 pd10 width100Rest sp_dpb" style="clear: both;">
        <div class="row">
          <div class="w50p mglrauto">
            <p>
              <a
                class="btn btn-block btn-Green"
                @click="showKoreaGuidanceModal = false"
              >
                閉じる
              </a>
            </p>
          </div>
        </div>
      </div>
    </tk-modal>
    <!-- END 韓国ホテルご予約に関するご案内 -->

    <!-- ご予約に関するご案内 -->
    <div class="alert alert-danger bar_title" role="alert">
      <div class="Bg_f7f5f0">
        <button
          type="button"
          class="alert-guidance-btn reservation"
          @click="showModal = true"
        >
          <i class="info_caution"></i>
          <h5 class="mgr40 fs14">ご予約の確認事項</h5>
          <p class="alert-guidance-details fwB">
            <i class="fa fa-chevron-circle-right fs16"></i>&nbsp;詳細はこちら
          </p>
        </button>
      </div>
    </div>
    <!-- END ご予約に関するご案内 -->
    <tk-modal
      v-if="showModal"
      modal-size="lg"
      no-show-header
      :no-sp-fullscreen="true"
      style="padding-right: 0px;"
    >
      <h3 class="text-center pdt30"><strong>ご予約の確認事項</strong></h3>
      <br />
      <br />
      <div class="row pdl40 pdr40 pdb30">
        <span style="font-size: 14px;">
          <strong>【宿泊の制限について】</strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>
            ●現地の法律や制度、ホテル側独自の規定で、年齢等の制限により宿泊が禁止されている場合がございます。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>【ベッドのご用意について】</strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>
            ●ご予約いただいた人数に関わらず、ベッドの台数・種類は事前に確約できません。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>
            &emsp;ご希望のご連絡をいただいた場合はリクエストとしてのみお受けいたします。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>
            ●エキストラベッドは追加の手配となるため、ホテルにより追加料金がかかる場合がございます。追加料金はチェックアウト時にお支払いください。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>&emsp;エキストラベッドの数には限りがあります。</strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>
            &emsp;また、ご用意がないホテル、お部屋が小さく搬入ができない場合など、リクエストに添えない場合もございます。
          </strong>
        </span>
        <br />
        <span style="font-size: 14px;">
          <strong>&emsp;あらかじめご了承ください。</strong>
        </span>
      </div>
      <div class="Price_back2 pd10 width100Rest sp_dpb" style="clear: both;">
        <div class="row">
          <div class="w50p mglrauto">
            <p>
              <a class="btn btn-block btn-Green" @click="showModal = false">
                閉じる
              </a>
            </p>
          </div>
        </div>
      </div>
    </tk-modal>
  </div>
</template>

<script>
import TkModal from '../../atoms/TkGlobalModal/TkGlobalModal'

export default {
  name: 'TkHotelAlertDander',
  components: { TkModal },
  props: {
    targetCountry: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      showModal: false,
      showKoreaGuidanceModal: false,
    }
  },
}
</script>
